import React, { useState } from 'react';
import { cidades, tiposTelha } from './dadosProposta';
import { cpf, cnpj } from 'cpf-cnpj-validator';

function validarCpfCnpj(valor) {
  const num = valor.replace(/\D/g, '');
  if (num.length === 11) return cpf.isValid(num);
  if (num.length === 14) return cnpj.isValid(num);
  return false;
}

function formatCpfCnpj(value) {
  const num = value.replace(/\D/g, '');
  if (num.length <= 11) {
    return num
      .replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1-$2')
      .slice(0, 14);
  }
  return num
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .slice(0, 18);
}

function FormProposta({ formData, onChange, onSubmit }) {
  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {
    switch (name) {
      case 'cliente_nome':
        if (!value) return 'Campo obrigatório';
        break;
      case 'cliente_cpf_cnpj':
        if (value && !validarCpfCnpj(value)) return 'CPF ou CNPJ inválido';
        // Se estiver vazio, não retorna erro
        break;
      case 'rua_numero':
        if (!value) return 'Campo obrigatório';
        break;
      case 'cidade':
        if (!value || !cidades.includes(value)) return 'Selecione uma cidade válida';
        break;
      case 'energia':
        if (!value) return 'Campo obrigatório';
        break;
      case 'tipo_telha':
        if (!value) return 'Campo obrigatório';
        break;
      default:
        return undefined;
    }
    return undefined;
  };

  // Limpa erro ao editar e valida ao sair do campo
  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: undefined }));
    }
    // Para CPF/CNPJ, só aceita números
    if (name === 'cliente_cpf_cnpj') {
      const onlyNums = value.replace(/\D/g, '');
      onChange({ target: { name, value: onlyNums } });
    } else {
      onChange(e);
    }
  };

  const handleFieldBlur = (e) => {
    const { name, value } = e.target;
    const error = validateField(name, value);
    if (error) {
      setErrors((prev) => ({ ...prev, [name]: error }));
    } else if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: undefined }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};
    Object.entries(formData).forEach(([name, value]) => {
      const error = validateField(name, value);
      if (error) newErrors[name] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      onSubmit(e);
    }
  };

  const getInputClass = (field) => 'form-control' + (errors[field] ? ' is-invalid' : '');

  return (
    <form onSubmit={handleSubmit}>
      <div className='mb-3'>
        <input
          type='text'
          name='cliente_nome'
          className={getInputClass('cliente_nome')}
          placeholder='Nome do cliente'
          value={formData.cliente_nome}
          onChange={handleFieldChange}
          onBlur={handleFieldBlur}
        />
        {errors.cliente_nome && <div className='invalid-feedback'>{errors.cliente_nome}</div>}
      </div>
      <div className='mb-3'>
        <input
          type='text'
          name='cliente_cpf_cnpj'
          className={getInputClass('cliente_cpf_cnpj')}
          placeholder='CPF ou CNPJ'
          value={formatCpfCnpj(formData.cliente_cpf_cnpj)}
          onChange={handleFieldChange}
          onBlur={handleFieldBlur}
          inputMode='numeric'
        />
        {errors.cliente_cpf_cnpj && <div className='invalid-feedback'>{errors.cliente_cpf_cnpj}</div>}
      </div>
      <div className='mb-3'>
        <input
          type='text'
          name='rua_numero'
          className={getInputClass('rua_numero')}
          placeholder='Endereço (Rua, Número, Bairro)'
          value={formData.rua_numero}
          onChange={handleFieldChange}
          onBlur={handleFieldBlur}
        />
        {errors.rua_numero && <div className='invalid-feedback'>{errors.rua_numero}</div>}
      </div>
      <div className='mb-3'>
        <select
          name='cidade'
          className={getInputClass('cidade')}
          value={formData.cidade || cidades[0]}
          onChange={handleFieldChange}
          onBlur={handleFieldBlur}
          style={{ maxHeight: '100px', overflowY: 'auto' }}
        >
          {cidades.map((cidade) => (
            <option key={cidade} value={cidade}>
              {cidade}
            </option>
          ))}
        </select>
        {errors.cidade && <div className='invalid-feedback'>{errors.cidade}</div>}
      </div>
      <div className='mb-3'>
        <input
          type='number'
          name='energia'
          className={getInputClass('energia')}
          placeholder='Consumo mensal (kWh)'
          value={formData.energia}
          onChange={handleFieldChange}
          onBlur={handleFieldBlur}
          min={0}
          step='any'
        />
        {errors.energia && <div className='invalid-feedback'>{errors.energia}</div>}
      </div>
      <div className='mb-3'>
        <select
          name='tipo_telha'
          className={getInputClass('tipo_telha')}
          value={formData.tipo_telha || tiposTelha[0]}
          onChange={handleFieldChange}
          onBlur={handleFieldBlur}
        >
          {tiposTelha.map((tipo) => (
            <option key={tipo} value={tipo}>
              {tipo}
            </option>
          ))}
        </select>
        {errors.tipo_telha && <div className='invalid-feedback'>{errors.tipo_telha}</div>}
      </div>
      <button type='submit' className='btn btn-primary w-100'>
        Calcular Proposta
      </button>
    </form>
  );
}

export default FormProposta;
